import React, { memo, useCallback } from 'react';
import { useAppDispatch, useAppSelector } from 'store/configureStore';
import {
  actionHandleShowCRFPartnerExpandedViewModal,
  toggleCRFProductConnectModal,
} from 'store/reducers/modal';
import { showCRFPartnerExpandedViewModalSelector } from 'store/selectors/modal';

import { phoneConstant } from '_constants/otherConstants';
import { useMediaQuery } from 'react-responsive';
import useTenantTranslation from 'utils/hooks/useTenantTranslation';
import BaseModal from '../BaseModal';
import CRFCardExpandedView from './CRFCardExpandedView';
import './style.scss';

const CRFPartnerExpandedViewModal: React.FC = () => {
  const modalData = useAppSelector(showCRFPartnerExpandedViewModalSelector);
  const dispatch = useAppDispatch();
  const { t } = useTenantTranslation();

  const handleClose = useCallback(() => {
    dispatch(actionHandleShowCRFPartnerExpandedViewModal(null));
  }, [dispatch]);

  const handleConnect = useCallback(() => {
    if (modalData && modalData.productId) {
      dispatch(
        toggleCRFProductConnectModal({ productId: modalData.productId }),
      );
    }
    handleClose();
  }, [dispatch, modalData, handleClose]);

  const isPhone = useMediaQuery({ query: `(max-width: ${phoneConstant}px)` });

  if (!modalData) return null;

  return (
    <BaseModal
      onModalClose={handleClose}
      isCloseIconVisible
      closeOnBackgroundClick
      backgroundScrollDisabled
      modalTitle={t('funding_module.about_funding_product', {
        productName: modalData.partnerName,
      })}
      headerIcon={
        <img
          src={modalData.logo}
          alt="Partner Logo"
          width="80"
          height="80"
          style={{ borderRadius: '50%' }}
        />
      }
      modalDescription={modalData.description}
      classNames={{
        modalContainer: 'custom_modal_container',
        modal: 'custom_modal',
        modalInnerContainer: 'custom_modal_inner_container',
        modalHeader: 'custom_modal_header',
        modalTitle: 'custom_modal_title',
        modalContent: 'custom_modal_content',
        modalFooter: 'custom_modal_footer_center',
      }}
      withAcceptButton
      acceptButtonText="Connect"
      acceptButtonStyle={{ width: '100%' }}
      acceptButtonSize="large"
      onAcceptButtonClick={handleConnect}
      modalDescriptionMaxLines={isPhone ? 6 : 10}
    >
      <CRFCardExpandedView data={modalData} />
    </BaseModal>
  );
};

export default memo(CRFPartnerExpandedViewModal);
